import React from "react";
import { useNavigate } from "react-router-dom";
import { IconBellRinging } from "@tabler/icons-react";
import { useSelector } from "react-redux";

const Header = ({ title, showBackButton = false }) => {
  const { user, roles } = useSelector((state) => state.auth); // Access user and roles from Redux
  const navigate = useNavigate();
  
  return (
    <header className="h-16 bg-white flex items-center justify-between px-6 shadow-sm">
      {/* Left Section: Back Button and Title */}
      <div className="flex items-center gap-4">
        {/* Back Button (optional) */}
        {showBackButton && (
          <button
            onClick={() => navigate(-1)} // Navigate back to the previous page
            className="px-4 py-2 bg-[#FFD500] text-[#0B0C52] rounded-md font-semibold hover:bg-[#FFC700]"
          >
            ← Back
          </button>
        )}
        {/* Title */}
        <h2 className="text-xl font-semibold text-[#0B0C52]">{title}</h2>
      </div>

      {/* Right Section: User Info and Icons */}S
      <div className="flex items-center gap-4">
        {/* Language Selector */}
        {/* <button className="border border-gray-300 text-sm rounded px-3 py-1 hover:bg-gray-100">
          Eng <span className="ml-2">&#x25BE;</span>
        </button> */}


        {/* User Info */}
        {user && (
          <div className="flex items-center gap-2">
            <div
              className={`w-3 h-3 rounded-full ${user.account_status === "active" ? "bg-green-500" : "bg-red-500"
                }`}
              title={user.account_status === "active" ? "Active" : "Inactive"}
            ></div>
          </div>
        )}
        {user && (
          <div className="flex items-center gap-2">
            <div className="text-right">
              <p className="text-sm font-semibold text-[#0B0C52]">
                {user.full_name || "User Name"}
              </p>
              <p className="text-xs text-gray-500">
                ({roles})
              </p>
            </div>
            <div className="w-8 h-8 rounded-full bg-gray-300 overflow-hidden">
              <img
                src={user.profile_picture || "/path/to/default-avatar.png"}
                alt="User Avatar"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;